module.exports = __webpack_public_path__ + "img/homephone.621c8bcd.svg";